import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { L10nTranslationModule } from 'angular-l10n';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { ImageModule } from '@nano/common/image';

import { IconWithPopoverComponent } from './icon-with-popover.component';

@NgModule({
  imports: [CommonModule, L10nTranslationModule, NzPopoverModule, ImageModule],
  declarations: [IconWithPopoverComponent],
  exports: [IconWithPopoverComponent]
})
export class IconWithPopoverModule {}
